import { Icon } from "@blockdaemon-internal/precision-ui";
import { Button } from "@mantine/core";
import { useWalletConnection } from "../hooks/use-wallet-connection";

export function WalletConnectButton({
  variant = "primary",
  size = "md",
}: {
  variant?: "primary" | "secondary";
  size?: "sm" | "md" | "lg";
}) {
  const { isConnected, connect, disconnect } = useWalletConnection();

  const handleClick = () => {
    if (isConnected) {
      disconnect();
    } else {
      connect();
    }
  };

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      leftIcon={<Icon icon={isConnected ? "logout" : "account_balance_wallet"} />}
      size={size}
      data-testid="wallet-connect-button"
    >
      {isConnected ? "Disconnect Wallet" : "Connect Wallet"}
    </Button>
  );
}
